import { IFetcher, IFetchRequest, Method } from '../../interface/util';
import { IAuthenticateResponse } from '../interface/auth';
import form from '../private/form';

function _request(
    apiUrl: string,
    apiExtension: string,
    clientId: string,
    clientSecret: string,
    grantType: string,
    username: string,
    password: string,
): IFetchRequest {
    const authParams = {
        client_id: clientId,
        client_secret: clientSecret,
        grant_type: grantType,
        username: username,
        password: password,
    };

    const req = {
        url: apiUrl + apiExtension,
        method: 'POST' as Method,
        body: form.serialize(authParams),
        headers: [{ name: 'Content-Type', value: 'application/x-www-form-urlencoded' }],
    };

    return req;
}

function authenticate(
    fetcher: Promise<IFetcher>,
    apiUrl: string,
    apiExtension: string,
    authParams: {
        clientId: string;
        clientSecret: string;
        grantType: string;
        username: string;
        password: string;
    },
    timeout: number = 10 * 1000,
): Promise<IAuthenticateResponse> {
    return new Promise(function (resolve, reject) {
        const req = _request(
            apiUrl,
            apiExtension,
            authParams.clientId,
            authParams.clientSecret,
            authParams.grantType,
            authParams.username,
            authParams.password,
        );

        fetcher
            .then(fetchLoader => fetchLoader(req, timeout))
            .then(function (response) {
                let error: string | null = null;

                if (response.statusCode === 400) {
                    error = 'Invalid credentials, authentication failed';
                } else if (!response.isStatusOk) {
                    error = `Authentication failed: ${response.statusCode}`;
                } else if (
                    !response.payload ||
                    !(response.payload as IAuthenticateResponse | null)?.access_token
                ) {
                    error = 'Missing access_token in auth response';
                }

                if (error) {
                    reject(error);
                } else {
                    const data =
                        response.payload as IAuthenticateResponse; /* already checked for null above */
                    resolve(data);
                }
            })
            .catch(function (err: Error) {
                console.error('Authentication failed: ' + JSON.stringify(err));
                reject(err);
            });
    });
}

export default authenticate;
